import { useRegionTreeSelect } from "../RegionTreeSelectContext";

import type { SyntheticEvent } from "react";
import type { RegionWithCountries } from "../types";

export function useRegionItem() {
  const { selectedCountries, onUpdate } = useRegionTreeSelect();

  const countSelectedCountries = (region: RegionWithCountries) =>
    region.countries.filter(({ id: countryId }) =>
      selectedCountries.some(
        ({ id: selectedCountryId }) => selectedCountryId === countryId
      )
    ).length;

  const isRegionSelected = (region: RegionWithCountries) =>
    countSelectedCountries(region) === region.countries.length;

  const isRegionIndeterminate = (region: RegionWithCountries) => {
    const selectedCountries = countSelectedCountries(region);

    return (
      selectedCountries !== 0 && selectedCountries !== region.countries.length
    );
  };

  const handleToggleRegion = (region: RegionWithCountries) => (
    event: SyntheticEvent
  ) => {
    event.stopPropagation();

    if (isRegionSelected(region)) {
      onUpdate(
        selectedCountries.filter(
          ({ id: selectedCountryId }) =>
            !region.countries.some(
              ({ id: countryId }) => countryId === selectedCountryId
            )
        )
      );

      return;
    }

    if (isRegionIndeterminate(region)) {
      onUpdate([
        ...selectedCountries,
        ...region.countries.filter(
          ({ id: countryId }) =>
            !selectedCountries.some(
              ({ id: selectedCountryId }) => selectedCountryId === countryId
            )
        ),
      ]);

      return;
    }

    onUpdate([...selectedCountries, ...region.countries]);
  };

  return {
    isRegionSelected,
    isRegionIndeterminate,
    handleToggleRegion,
  };
}
